import { Form as FormProps } from "./index.types";
import "./index.css";
import Button from "../button";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { FormProvider, useForm } from "react-hook-form";
import { useState } from "react";

// how do I solve reseting the form outside the form
export function Form({
  children,
  onSubmit,
  submitButton = {
    label: "Submit",
  },
  initialState,
  backgroundColor,
  ...rest
}: FormProps) {
  const methods = useForm({ mode: "onChange", ...initialState });

  const {
    formState: { isValid },
  } = methods;

  const [result, setResult] = useState<{
    message?: string;
    isSuccess: boolean;
  }>({
    message: "",
    isSuccess: false,
  });

  return (
    <FormProvider {...methods}>
      <form
        className="form"
        style={{ backgroundColor: backgroundColor }}
        onSubmit={methods.handleSubmit((data) => {
          return onSubmit(data, methods, setResult);
        })}
        {...rest}
      >
        {children}
        {result.message && (
          <div className="form__message">
            {result.isSuccess ? (
              <BsCheckCircleFill
                color="var(--color-success)"
                size={48}
              ></BsCheckCircleFill>
            ) : (
              <BsXCircleFill
                color={"var(--color-danger)"}
                size={48}
              ></BsXCircleFill>
            )}
            {result.message}
          </div>
        )}
        <Button type="submit" disabled={!isValid}>
          {submitButton.label}
        </Button>
      </form>
    </FormProvider>
  );
}

export default Form;
